import React from 'react';
import classnames from 'classnames';

import { Input } from 'components/shared';
import Icon from 'assets/icons';

import styles from './AddMember.module.scss';

export interface AddMemberProps {
  /** @boolean If the group heading should render with an alternate style */
  alternateStyle?: boolean;
  /** @string Membery query text */
  query?: string;
  /** @boolean If this instance of AddMember should show it's active state */
  active?: boolean;
  /** @boolean If this instance of AddMember should render or hide */
  hidden?: boolean;
  onChange?: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
}

export const AddMember: React.FC<AddMemberProps> = ({
  query,
  active,
  hidden,
  onBlur,
  onFocus,
  onChange,
  alternateStyle
}) => {
  const classes = classnames(styles.container, alternateStyle && styles.alternate,{ [styles.hidden]: hidden });

  /**
   * Called when the PlusCircle icon is clicked
   * Enters editing mode
   */
  const handleEdition = React.useCallback(() => {
    onFocus && onFocus();
  }, [onFocus]);

  /**
   * Called when the Input field is being changed by the user
   */
  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange && onChange(e.target.value);
    },
    [onChange]
  );

  /**
   * Handles the input cancel state
   */
  const handleCancel = React.useCallback(() => {
    onBlur && onBlur();
  }, [onBlur]);

  return (
    <div className={classes}>
      <Icon.PlusCircle 
        className={classnames(
          styles.icon,
          alternateStyle && styles.alternate
        )} 
        onClick={handleEdition} />

      <Input
        autoFocus={active}
        theme="Naked"
        size="Medium"
        value={query}
        className={classnames(styles.input, styles.dots)}
        onClick={handleEdition}
        onCancel={handleCancel}
        onChange={handleChange}
      />
    </div>
  );
};
